export const JIRA_INTAKE_SETUP_COPY = {
  setupButton: "Setup Jira",
} as const;
